<template>
    <div class="form-btn-top">
        <slot></slot>
    </div>
</template>

<style>
</style>

<script>
    export default {
        data () {
            return {
            }
        },
        components: {
        }
    }
</script>